import { styled } from '@/styled-system/jsx';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link, {
  variants: {
    isActive: {
      true: {
        color: 'text.accent.brand.hero',
      },
      false: {
        color: 'text.subtle',
      },
    },
  },
});
